import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

type Props = {
  title: string;
  description?: string;
  end?: JSX.Element;
  titleImage?: JSX.Element;
  className?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
};

export function EPageTitle({ title, titleImage, description, end, className, showBackButton, onBackClick }: Readonly<Props>) {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className={`md:flex md:justify-between items-center w-full py-1.5 ${className}`}>
      {/* {end ? <div className="right flex flex-row gap-1">{end}</div> : null} */}
      <div className="flex items-end gap-2">
        {showBackButton && (
          <div className="align-center">
            <button
              onClick={handleBackClick}
              className="flex items-center bg-green-400  text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-md transition-colors mr-2 p-2"
              aria-label="Go back"
            >
              <BsArrowLeft className="text-lg" />
            </button>
          </div>
        )}
        {
          titleImage ?
            <div className="mr-2">
              {titleImage}
            </div>
            : <></>
        }
        <div className="flex-1 mb-2 md:mb-0 leading-tight">
          <div className="text-2xl font-semibold text text-slate-600">
            {title}
          </div>
          <div className="text-base text-slate-400 -mt-1">{description}</div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {end ? end : null}
      </div>
    </div>
  );
}
